<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Menu</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row">
      <div class="col-md-1">
        <h4 class="mt-2">Company</h4>
      </div>
      <div class="col-md-5 fit-content">
        <select class="form-control" v-model="company" @change="changeCompany">
          <option
            v-for="company in companies"
            :key="company.CompanyName"
            :value="company.CompanyName"
          >
            {{ company.CompanyName }}
          </option>
        </select>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Content -->
    <table class="table table-bordered custom-table mt-4 mb-0">
      <template v-for="menu in menus">
        <tr :key="menu.Parent" v-if="menu.Parent">
          <td class="setting-subtitle py-1">
            <h3 class="setting-subtitle">{{ menu.Parent }}</h3>
          </td>
        </tr>
        <tr v-for="item in menu.Children" :key="item.Id">
          <td class="pb-2 pt-2 menu-cell">
            <input
              class="mr-2"
              type="checkbox"
              v-model="item.Selected"
              :id="'chk' + item.Id"
            />
            <label :for="'chk' + item.Id">{{ item.Name }}</label>
          </td>
        </tr>
      </template>
    </table>
    <div class="button-div mt-2 text-center">
      <button @click="save" type="button" class="btn btn-primary">
        <i class="fa fa-save"></i> Save
      </button>
    </div>
    <!-- /Content -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      company: config.DEFAULT_COMPANY,
      companies: [],
      menus: [],
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            this.company = this.companies[0].CompanyName;
            this.getMenus();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getMenus() {
      let param = {
        Token: this.token,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getMenus(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.menus = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    changeCompany() {
      this.getMenus();
    },
    save() {
      let param = {
        Token: this.token,
        Company: this.company,
        Menus: this.menus,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the menus?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveMenus(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              if (response.data.success) {
                this.$swal("Menus saved successfully!", {
                  icon: "success",
                });
              } else {
                this.$swal(response.data.message, { icon: "error" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },

  created() {
    if (this.role != "admin")
      this.$router.replace({ name: "home" });

    this.getCompanies();
  },
};
</script>

<style scoped>
table,
.button-div {
  width: 800px;
}

.fit-content {
  max-width: fit-content !important;
}

h3.setting-subtitle {
  font-size: 20px;
}

.menu-cell input,
.menu-cell label {
  cursor: pointer;
}
.menu-cell {
  display: flex;
  align-items: center;
}
.menu-cell label {
  margin-bottom: 0;
  margin-top: 2px;
}
</style>




// WEBPACK FOOTER //
// src/components/System/Menu.vue